import axios from '@axios';

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchTemplates(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        // delete queryParams.filter;

        axios
          .get('integration/monday/templates', { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchTemplate(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`integration/monday/templates/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updateTemplate(ctx, { id, templateData }) {
      delete templateData.id;
      delete templateData.updatedAt;
      delete templateData.createdAt;

      if (templateData.attachments) {
        templateData.attachments = templateData.attachments.map((ac) => {
          delete ac._id;
          delete ac.id;
          return ac;
        });
      }

      return new Promise((resolve, reject) => {
        axios
          .patch(`integration/monday/templates/${id}`, templateData)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    createTemplate(ctx, templateData) {
      return new Promise((resolve, reject) => {
        axios
          .post(`integration/monday/templates`, templateData)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    addCohort(ctx, { cohortData }) {
      return new Promise((resolve, reject) => {
        axios
          .post('placement/cohorts', cohortData)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchCohorts(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        // delete queryParams.filter;

        axios
          .get('placement/cohorts', { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchCohort(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`placement/cohorts/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updateCohort(ctx, { cohortId, cohortData }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`placement/cohorts/${cohortId}`, cohortData)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchCohortSummary(ctx, { id }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`placement/cohorts/${id}/summary`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    downloadCohortAsRecruiter(ctx, { cohortId, queryParams }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`placement/cohorts/${cohortId}/export/recruiter`, { params: queryParams, responseType: 'blob' })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    addStudentsToCohort(ctx, { cohortId, studentIds, profileIds }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/placement/cohorts/${cohortId}/students`, { studentIds, profileIds })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    removeStudentsFromCohort(ctx, { cohortId, studentIds, profileIds }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/placement/cohorts/${cohortId}/students`, { data: { studentIds, profileIds } })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    fetchProfiles(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        // delete queryParams.filter;

        axios
          .get('placement/profiles', { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    fetchProfile(ctx, { id, queryParams }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`placement/profiles/${id}`, { params: queryParams })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    updateProfile(ctx, { id, profileData }) {
      return new Promise((resolve, reject) => {
        axios
          .patch(`placement/profiles/${id}`, profileData)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
